<template>
  <v-dialog v-model="dialog" width="60vw" :content-class="getClassName()">
    <v-form ref="nottAdd" v-model="nottAddValid" class="flex bg-form">   
      <v-card flat class="flex bg-form">
        <v-card width="35vw" height="80vh" flat>
          <v-container>           
            <div class="flex card-title">
              <div><h3>{{ nott.nott_tabel_oms }} - {{ nott.nott_key1 }}</h3></div>                            
              <div>
                <v-select v-if="noto_omsKeuzes.length !== 0"  v-model="selected_noto_oms" v-bind:items="noto_omsKeuzes"
                  prepend-icon="mdi-filter-outline" item-value="noto_oms" item-text="noto_oms" label="Filter on subject"
                  dense class="pl-3 pt-1 filter" clearable></v-select>
              </div>
              <div v-if="noto_omsKeuzes.length !== 0" class="ml-8"><h5>{{notes.length}} notes found</h5></div>
            </div>
            <div v-if="noto_omsKeuzes.length === 0"><h5>{{notes.length}} notes found</h5></div>
              <ul class="ul">
                <li v-for="(nottRecord, i) in filteredNotes" :key="i">  
                  <v-card width="100%" class="note-background note">
                    <v-container>
                      <div class="note-title flex">
                        <div class="date-time">{{ nottRecord.nott_dt }} </div>
                        <div class="gebr">{{ nottRecord.gebr_naam }}</div>
                        <div class="category">{{ nottRecord.noto_oms }}</div>
                        <div v-if="nottRecord.nott_prio===1">
                          <v-icon :size="20" class="delete-note mr-2" @click="pinNott(nottRecord)"  color="red">mdi-pin</v-icon>
                        </div>
                        <div v-else>
                          <v-icon :size="20" class="delete-note mr-2" @click="pinNott(nottRecord)">mdi-pin-off</v-icon>
                        </div>
                        <div v-if="noto_omsKeuzes.length !== 0"><v-icon :size="20" class="delete-note" @click="deleteNott(nottRecord)">mdi-trash-can-outline</v-icon></div>
                      </div>
                      <v-divider></v-divider>
                      <div v-html="nottRecord.nott_tekst" class="note-text" @click="updNott(nottRecord.nott_encrid, nottRecord.nott_tekst, nottRecord.noto_oms)"></div>
                    </v-container>
                  </v-card>
                </li>
              </ul>       
          </v-container>
        </v-card>
        <v-card width="25vw" height="80vh" flat>
          <v-container>
            <v-row no-gutters class="mx-5" style="margin-top: 70px">
              <v-col cols=12>
                <h3>{{ title }}</h3>
              </v-col> 
            </v-row>        
            <v-row no-gutters class="mx-5">
              <v-col cols=12>
                <v-select v-if="noto_omsKeuzes.length!==0" v-model="noto_oms" :items="noto_omsKeuzes" item-value="noto_oms" item-text="noto_oms" label="Subject" :error-messages="errors1" @change="validSubject(noto_oms)"></v-select>
              </v-col>  
              <v-col cols=12>
                <v-textarea v-model="nott_tekst" rows="5" label="Note text"></v-textarea> 
              </v-col> 
            </v-row>
            <v-row no-gutters class="mx-5">
              <v-col cols=12>
                <v-text-field v-model="nott_url" label="URL"></v-text-field> 
              </v-col> 
            </v-row>
            <v-row no-gutters class="mx-5">
              <v-col cols=12>
                <v-text-field v-model="nott_url_tekst" label="URL tekst"></v-text-field> 
              </v-col> 
            </v-row>        
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="caption === 'Update'" class="warning mx-2" small @click="undoUpdate">Undo</v-btn>
              <v-btn class="primary mx-2" small @click="addNott">{{ caption }}</v-btn>        
              <v-btn color="primary"  small @click="dialog = false">Close</v-btn>        
            </v-card-actions>
          </v-container>
        </v-card>
      </v-card>
    </v-form> 
  </v-dialog>
</template>
  
<script>
  
  import {bus} from "../main";
  
  export default {
    components: {
    },  
    data() {
      return {
        dialog: false,
        title: '',
        caption: '',
        nott: {},
        nott_tekst: '',
        nott_url: '',
        noto_oms: '',
        nott_oms: '',
        encrid: '',
        nott_url_tekst: '',
        nottAddValid: false,
        nott_encrid: '',
        noto_omsKeuzes: [],
        noto_hasempty:false,
        selected_noto_oms: '',
        tabel: '',
        errors1: [],
        notes: [],
        contentclass: 'my-custom-dialog', 
        nott_tekstRules: [
            v => (v && v!==null && v.length >= 3) || "A description is required"
        ]  
      }
    },
    computed:{
      filteredNotes:function() {
        try{
          return this.notes.filter((nott) => {
            if (this.selected_noto_oms===''||this.selected_noto_oms===null){
              return true;
            } else{
              return this.selected_noto_oms===nott.noto_oms
            }
          })
        } catch {
          return true;
        }
      }
    },
    methods: {
      open(tabel,encrid,nott_oms) {
        console.log('tabel', tabel);
        this.errors1=[];
        this.noto_omsKeuzes=[];
        this.$emit("showSnackbar");
        this.dialog = true;
        this.tabel = tabel;
        this.encrid = encrid;
        this.nott_oms = nott_oms;
        this.nott = {};
        this.notes = [];
        this.noto_oms = '';
        this.nott_tekst = '';
        this.nott_url = '';
        this.nott_encrid = '';
        this.nott_url_tekst = '';
        this.selected_noto_oms = '';
        this.title = 'Add new note';
        this.caption= 'Add';
        if (this.tabel==="heho"&&this.nott_oms!==""&&this.nott_oms!=="all") {
            this.noto_oms = this.nott_oms;
            this.selected_noto_oms = this.nott_oms;
        }
        this.getNott();
      },
      notifyParent(param) {
        bus.$emit("addNote", param);
      },    
      showNott(url) {
        window.open(url,'_blank');
      },
      getNott(){
        this.$axios
          .post("ares/json/ares/misc/getNott.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "getNott"
            },
            getNott: {
              tabel: this.tabel,
              encrid: this.encrid,
              nott_oms: this.nott_oms
            }
          })
          .then(res => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.nott = res.data.getNott;
              this.notes = res.data.getNott.nott;
              this.noto_omsKeuzes = res.data.getNott.noto_omsKeuzes;
              this.noto_hasempty = res.data.getNott.noto_hasempty;
              this.$emit('updateParentNoteData', this.notes.length);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      validSubject(v){
        this.errors1 = [];
        v===''&&this.noto_omsKeuzes.length!==0&&!this.noto_hasempty?this.errors1.push('Subject is mandatory for a note'):false                
        return this.errors1.length===0;             
      },   
      pinNott(nott) {
        this.$axios
          .post("ares/json/ares/misc/pinNott.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "pinNott"
            },
            pinNott: {
              nott_encrid: nott.nott_encrid,
            }
          })
          .then(res => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.undoUpdate(); // clear any ongoing updates
              this.getNott();
            }
          })        
      },
      deleteNott(nott){
        this.$axios
          .post("ares/json/ares/misc/deleteNott.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "deleteNott"
            },
            deleteNott: {
              nott_encrid: nott.nott_encrid,
            }
          })
          .then(res => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.undoUpdate(); // clear any ongoing updates
              this.getNott();
            }
          })
      },   
      addNott() { 
        // console.log('add note', this.noto_oms);
        // check for 
        if(!this.validSubject(this.noto_oms)){
          return
        }
        this.$axios
          .post("ares/json/ares/misc/addNott.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "addNott"
            },
            addNott: {
              tabel: this.nott.tabel,
              encrid: this.nott.encrid,
              nott_encrid: this.nott_encrid,
              nott_oms: this.nott.nott_oms,
              noto_oms: this.noto_oms,
              nott_tekst: this.nott_tekst,
              nott_url: this.nott_url,
              nott_url_tekst: this.nott_url_tekst
            }
          })
          .then(res => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              if (this.tabel !== 'revw' &&
                  this.tabel !== 'hogr' && 
                  this.tabel !== 'huis' &&
                  this.tabel !== 'huov' &&
                  this.tabel !== 'inpt' &&
                  this.tabel !== 'klnt' &&
                //   this.tabel !== 'pten' &&
                //   this.tabel !== 'heho' &&
                  this.tabel !== 'eign') {
                this.$store.dispatch('setSnackbar', {
                  showing: true,
                  text: res.data.addNott.text,
                  color: res.data.addNott.color
                });
                this.dialog = false;
                if (res.data.addNott.color == "success") {
                  location.reload();
                }
              } else {
                // revw of hogr = notifyParent that one (or no) note was added
                if(this.nott_tekst.trim()!==''){
                  this.$emit('addNote', 1);
                  this.notifyParent(1);
                  this.$store.dispatch('setSnackbar', {
                    showing: true,
                    text: res.data.addNott.text,
                    color: res.data.addNott.color
                  });                     
                } else {  
                  // this.notifyParent(1); 
                  // this.$store.dispatch('setSnackbar', {
                  //   showing: true,
                  //   text: res.data.addNott.text,
                  //   color: res.data.addNott.color
                  // });   
                }               
                //} else {
                //  this.notifyParent(0); 
                //} 
                this.dialog = false;
              }
            }
          })
      },
      updNott(nott_encrid,tekst,noto_oms) { 
        this.title = "Update note";
        this.caption = 'Update';
        this.nott_tekst = tekst;
        this.noto_oms = noto_oms;
        this.nott_encrid = nott_encrid;
      },
      undoUpdate(){
        this.title = "Add new note";
        this.caption= 'Add';
        this.nott_tekst = '';
        this.noto_oms = '';
        this.nott_encrid = '';
      },
      getClassName(){
        if(this.tabel==='huov'){
          return 'my-custom-dialog'
        } else {
          return ''
        }
      }
    }
  }
</script>

<style scoped>
  .flex{
    display: flex;
    flex-direction: row;
  }
  .my-custom-dialog {
    align-self:center;
    margin-left: auto !important;
  }
  .bg-form{
    background-color: white;
  }
  .note{
    margin-bottom: 10px;
  }
  .note-text{
    padding-top: 5px;
    cursor: pointer;
  }
  .note-title{
    font-size: large;
    font-weight: 475;
    cursor: default !important;
  }
  .note-background{
    background-color:rgb(255, 255, 213);
  }
  .card-title{
    margin-top: 8px;
  }
  .filter{    
    width: 250px !important;
  }
  .date-time{
    width:12vw;
  }
  .category{
    width:12vw;
  }
  .delete-note{
    cursor: pointer;
    margin-left: auto !important;
  }
  .gebr{
    width:12vw;
  }
  .ul {
    list-style-type: none !important;
    position:absolute;
    left: 0;
    right: 0;
    top: 70px;
    bottom: 20px;
    padding: 10px 10px;
    margin: 0;
    overflow-y: auto;
  }

</style>
  